<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.papel"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'administracao-papel-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-administracao-papel"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-administracao-papel"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories = {
            papel: this.getConectaSusRepository('administracao.papel')
        }
    },
    data: () => ({
        fields: [
            {
                name: 'papel.nome',
                key: 'nome',
                label: 'Nome',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
    }),
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.papel.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o papel?', destroy, this.handleError)
        },
    },
    mixins: [repository, error],
}
</script>